"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Absolute = exports.Grid = exports.Row = exports.Column = exports.Box = exports.blockStyles = exports.blockPadding = exports.blockPaddingBottom = exports.blockPaddingTop = exports.common = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const styled_system_1 = require("styled-system");
const defaultCmmon = [
    styled_system_1.background,
    styled_system_1.space,
    styled_system_1.flexbox,
    styled_system_1.border,
    styled_system_1.color,
    styled_system_1.position,
    styled_system_1.layout,
    styled_system_1.size,
    styled_system_1.opacity,
    styled_system_1.textAlign,
    styled_system_1.textStyle,
];
const spaces = (0, styled_components_1.css) `
  ${({ theme, margin }) => {
    var _a;
    return margin && (0, styled_components_1.css) `
    margin: ${(_a = theme.space[margin]) !== null && _a !== void 0 ? _a : margin};
  `;
}};
  ${({ theme, marginTop }) => {
    var _a;
    return marginTop && (0, styled_components_1.css) `
    margin-top: ${(_a = theme.space[marginTop]) !== null && _a !== void 0 ? _a : marginTop};
  `;
}};
  ${({ theme, marginBottom }) => {
    var _a;
    return marginBottom && (0, styled_components_1.css) `
    margin-bottom: ${(_a = theme.space[marginBottom]) !== null && _a !== void 0 ? _a : marginBottom};
  `;
}};
  ${({ theme, marginLeft }) => {
    var _a;
    return marginLeft && (0, styled_components_1.css) `
    margin-left: ${(_a = theme.space[marginLeft]) !== null && _a !== void 0 ? _a : marginLeft};
  `;
}};
  ${({ theme, marginRight }) => {
    var _a;
    return marginRight && (0, styled_components_1.css) `
    margin-right: ${(_a = theme.space[marginRight]) !== null && _a !== void 0 ? _a : marginRight};
  `;
}};

  ${({ theme, padding }) => {
    var _a;
    return padding && (0, styled_components_1.css) `
    padding: ${(_a = theme.space[padding]) !== null && _a !== void 0 ? _a : padding};
  `;
}};
  ${({ theme, paddingTop }) => {
    var _a;
    return paddingTop && (0, styled_components_1.css) `
    padding-top: ${(_a = theme.space[paddingTop]) !== null && _a !== void 0 ? _a : paddingTop};
  `;
}};
  ${({ theme, paddingBottom }) => {
    var _a;
    return paddingBottom && (0, styled_components_1.css) `
    padding-bottom: ${(_a = theme.space[paddingBottom]) !== null && _a !== void 0 ? _a : paddingBottom};
  `;
}};
  ${({ theme, paddingLeft }) => {
    var _a;
    return paddingLeft && (0, styled_components_1.css) `
    padding-left: ${(_a = theme.space[paddingLeft]) !== null && _a !== void 0 ? _a : paddingLeft};
  `;
}};
  ${({ theme, paddingRight }) => {
    var _a;
    return paddingRight && (0, styled_components_1.css) `
    padding-right: ${(_a = theme.space[paddingRight]) !== null && _a !== void 0 ? _a : paddingRight};
  `;
}};
`;
exports.common = (0, styled_components_1.css) `
  ${defaultCmmon};
  ${spaces}
  `;
exports.blockPaddingTop = (0, styled_components_1.css) `
  padding-top: ${({ theme, padding = "XL" }) => { var _a; return (_a = theme.space[padding]) !== null && _a !== void 0 ? _a : padding; }};
`;
exports.blockPaddingBottom = (0, styled_components_1.css) `
  padding-bottom: ${({ theme, padding = "XL" }) => { var _a; return (_a = theme.space[padding]) !== null && _a !== void 0 ? _a : padding; }};
`;
exports.blockPadding = (0, styled_components_1.css) `
  ${exports.blockPaddingTop};
  ${exports.blockPaddingBottom};
`;
exports.blockStyles = (0, styled_components_1.css) `
  width: 100%;
  margin: ${({ theme, margin = "XL" }) => { var _a; return (_a = theme.space[margin]) !== null && _a !== void 0 ? _a : margin; }} auto;
`;
exports.Box = styled_components_1.default.div `
  ${exports.common};
  background: ${({ theme, background }) => { var _a; return background && ((_a = theme.color[background]) !== null && _a !== void 0 ? _a : background); }};
  position: relative;
`;
exports.Column = styled_components_1.default.div `
  ${exports.common};
  display: flex;
  flex-direction: ${({ flexDirection = "column" }) => flexDirection};
`;
exports.Row = styled_components_1.default.div `
  ${exports.common};
  display: flex;
  background: ${({ theme, background }) => { var _a; return background && ((_a = theme.color[background]) !== null && _a !== void 0 ? _a : background); }};
`;
exports.Grid = styled_components_1.default.div `
  ${exports.common};
  display: grid;
`;
exports.Absolute = (0, styled_components_1.default)(exports.Box) `
  ${exports.common};
  position: absolute !important;
`;
//# sourceMappingURL=index.js.map